const paths = {
  orders: '/dkmall/dkmall-order/order-list', inquiries: '/dkmall/dkmall-order/inquiries',
  members: '/dkmall/member-management/members', inventory: '/dkmall/catalog/stock-warning',
  invoices: '/dkmall/dkmall-order/invoice', agents: '/dkmall/dkmall-customer-service/agents',
  comments: '/dkmall/catalog/comment'
}
export const queueNames = {
  confirm: '待确认', unpaid: '待付款', production: '设计 / 生产中', design: '待确认设计 / 样品',
  prepare: '准备发货', ship: '待发货', receive: '待收货', refund: '退款 / 取消处理中'
}
export const queueLabel = key => queueNames[key] || ''
export const typeName = type => ({ 3: '现货订单', 12: '定制采购', 13: '设计订单', 14: '样品订单', 16: '补差价' })[Number(type)] || '其他商城订单'
export const statusName = (value, received) => Number(value) === 3 && received != null ? (Number(received) > 0 ? '已签收' : '待收货') : ({ '-7': '待确认', '-6': '草拟订单', '-1': '已取消', '-2': '已取消', 0: '待付款', 1: '待发货', 2: '已发货', 3: '收货阶段', 4: '已完成', 5: '退款中', 6: '已退款', 7: '尾款待付', 8: '准备发货', 9: '设计 / 生产中', 10: '设计 / 生产中', 11: '待确认设计 / 样品', 12: '取消处理中' })[Number(value)] || '其他状态'
export function amount (value) {
  return value === null || value === undefined || value === '' || !Number.isFinite(Number(value)) ? '—' : new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value))
}
export function routeFor (routes, key) {
  const fallback = paths[key]
  const suffix = fallback.split('/').pop()
  const flatten = items => items.reduce((all, item) => all.concat(item, flatten(item.children || [])), [])
  const match = flatten(routes || []).find(item => item.path && item.path.includes('/dkmall/') && item.path.endsWith('/' + suffix))
  return match ? match.path : fallback
}
function epoch (date) { const [year, month, day] = date.split('-').map(Number); return Date.UTC(year, month - 1, day) / 1000 - 8 * 3600 }
export function orderQuery (snapshot, extra = {}) {
  if (extra.invoicePending || extra.workQueue || extra.orderSn || !snapshot || !snapshot.range || snapshot.range.all) return { ...extra }
  return { startTime: epoch(snapshot.range.start), endTime: epoch(snapshot.range.end) + 86400 - 1, ...extra }
}
